export function urlSanitizer(url: string) {
    const idInQueryParametersRegex = /([^&=?]+)=([\w-]*)/g;
    const idInPathOrQueryParametersRegex =
        /(\/|\b)(\d+|(\w{8}-\w{4}-\w{4}-\w{4}-\w{12}))(\b|\/)/g;
    return url
        .replaceAll(idInQueryParametersRegex, '$1=redacted')
        .replaceAll(idInPathOrQueryParametersRegex, '$1redacted$4');
}
